import { Icon20CalendarOutline } from '@vkontakte/icons';
import { Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import sharedCalendarImage from 'img/family-content/empty-block-family-calendar.png';
import sharedCalendarImageDark from 'img/family-content/empty-block-family-calendar-dark.png';
import { xray } from 'lib/xray';
import React from 'react';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { useFamilyCalendarClick } from 'reactApp/sections/FamilyPage/hooks/useFamilyCalendarClick';
import styles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';

interface SharedCalendarProps {
    paySource: string;
}

export const SharedCalendar: React.FC<SharedCalendarProps> = ({ paySource }) => {
    const onCalendarButtonClick = useFamilyCalendarClick({ paySource });

    const onClick = (): void => {
        xray.send('empty-family-calendar', { p: 'cloud' });
        onCalendarButtonClick?.();
    };

    return (
        <div className={styles.card} onClick={onClick} data-qa-id="family-shared-calendar">
            <div className={styles.icon}>
                <Icon20CalendarOutline data-qa-id="family-shared-calendar-icon" />
            </div>
            <Spacing size={24} style={{ pointerEvents: 'none' }} />
            <Title level="2" data-qa-id="family-shared-calendar-title">
                Планируйте общие дела в семейном календаре
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-shared-calendar-content">Добавляйте в него события — {'\n'}они появятся у всех в подписке</Text>
            <img
                src={isDarkTheme ? sharedCalendarImageDark : sharedCalendarImage}
                alt="Общие дела"
                className={classNames(styles.image, styles.familyImage)}
                data-qa-id="family-shared-calendar-image"
            />
        </div>
    );
};
